import { toast } from "@arcadeai/design-system/components/ui/molecules/toast";
import { StrongAuthRequiredDialog } from "@arcadeai/ui-kit/account-security";
import { useQuery } from "@tanstack/react-query";
import { appConfigQueryOptions } from "@/app/mcp-gateways/api/get-app-config";
import { authClient } from "@/lib/auth-client";
import { ACCOUNT_UI_URL } from "@/lib/const";
import { logoutAndRedirect } from "@/lib/logout";
import {
  leaveForStrongAuthSetup,
  strongAuthSetupUrl,
  useStrongAuthRequired,
} from "@/lib/strong-auth";

const SIGN_OUT_FAILED = "We couldn't sign you out of the Dashboard. Try again.";

/**
 * Sends an operator whose sign-in Arcade refused to Manage my account. The
 * Dashboard session ends first: its tokens describe the refused sign-in, and
 * Manage my account returns through the login page's auto sign-in, which only
 * starts a new sign-in when there's no session.
 */
export function StrongAuthRequired() {
  const required = useStrongAuthRequired();
  const accountUiUrl =
    useQuery(appConfigQueryOptions()).data?.accountUiUrl ?? ACCOUNT_UI_URL;
  return (
    <StrongAuthRequiredDialog
      onManageAccount={async () => {
        const left = await leaveForStrongAuthSetup({
          setupUrl: strongAuthSetupUrl(accountUiUrl, window.location.href),
          signOut: () => authClient.signOut(),
          navigate: (url) => window.location.assign(url),
        });
        if (!left) {
          toast.error(SIGN_OUT_FAILED);
        }
      }}
      onSignOut={() => {
        logoutAndRedirect().catch(() => toast.error(SIGN_OUT_FAILED));
      }}
      open={required}
    />
  );
}
